import { 
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken
} from 'keycloak-angular';
import { environment } from 'environments/environment';

/* Include on this list all the urls that should include the keycloak token on the request header */
const bearerProtectedUrls = [
  environment.graphql_http,
  environment.graphql_ws, // maybe this is not needed for the ws connection
  environment.graphql_http2,
  environment.graphql_ws2, // maybe this is not needed for the ws connection
  environment.graphql_datwind,
  environment.graphql_notifications,
  environment.graphql_multitech,
  environment.image_server,
  environment.dataStudioURL,
  environment.fileURL
];

const bearerTokenConditions = bearerProtectedUrls.map(url =>
  createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: new RegExp(url),
    bearerPrefix: 'Bearer',
  })
);

export const keycloakInitializer = () =>
  provideKeycloak({
    config: {
      url: environment.sso_url,
      realm: 'SDS',
      clientId: 'wind-log-fe'
    },
    initOptions: {
      onLoad: 'login-required',
      checkLoginIframe: false
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 600000000
      })
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: bearerTokenConditions
      },
    ]
  });
